import { HttpClient } from "@parkschannel/next-utils";
export class TagsApi {
    getTags(params) {
        return this.client.get("".concat(this.baseUrl), {
            params
        }, false);
    }
    constructor(client = new HttpClient()){
        this.client = client;
        this.baseUrl = "/api/tags";
    }
}
